import { ChangeEvent, useEffect, useState } from 'react';
import { Container, ErrorText, HelpText, LabelWrapper } from '../Input/Input.styles';
import Radio from '../Radio/Radio';
import { OptionsContainer, RadioGroupLabel } from './RadioGroup.styles';
import { RadioGroupLayouts, RadioGroupProps } from './RadioGroup.types';

const RadioGroup: React.FC<RadioGroupProps> = ({
  id,
  label,
  options,
  helpText,
  errorText,
  layout = RadioGroupLayouts.Column,
  onChange,
  selected,
}) => {
  const [selectedOption, setSelectedOption] = useState(selected);

  useEffect(() => {
    setSelectedOption(selected);
  }, [selected]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event);
    if (event.target.ariaDisabled === 'true') return; // prevents disabled radio options from being selected
    setSelectedOption(event.target.id);
  };

  const renderOptions = options.map((option) => (
    <Radio
      id={option.id}
      label={option.label}
      key={option.id}
      value={option.id}
      name={id}
      checked={selectedOption === option.id}
      onChange={handleChange}
      disabled={option.disabled}
    />
  ));

  return (
    <Container>
      <LabelWrapper>
        <RadioGroupLabel id={`${id}-label`}>{label}</RadioGroupLabel>
        {helpText ? <HelpText id={`${id}-help-text`}>{helpText}</HelpText> : <></>}
      </LabelWrapper>
      <OptionsContainer layout={layout} errorText={errorText} id={id} role='radiogroup' aria-labelledby={`${id}-label`}>
        {renderOptions}
      </OptionsContainer>
      {errorText ? (
        <ErrorText aria-live='assertive' id={`${id}-error-text`}>
          {errorText}
        </ErrorText>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default RadioGroup;
